@if (spinnerService.loading) {
  <app-spinner />
} 

<!-- @if (slideMenuService.showed) {
  <app-slide-menu />
} -->
<router-outlet></router-outlet>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>